import { InputDateMaskWebElementBase } from './InputDateMaskWebElementBase';

/**
 * The component WebElement for [oj-c-input-date-mask](../../jsdocs/oj-c.InputDateMask.html).
 * Do not instantiate this class directly, instead, use
 * [findInputDateMask](../functions/findInputDateMask.html).
 */
export class InputDateMaskWebElement extends InputDateMaskWebElementBase {
  // Put overrides here
}
